import React from "react";
import { Button } from "antd";

const OutlineButton = ({
  label,
  size = "lg",
  disable = false,
  onClick,
  htmlType = null,
  className,
  icon,
  width,
  style,
}) => {
  const { pixels, unit } = width || { pixels: null, unit: null };

  const styles = {
    width:
      width && typeof width === "object" ? `${pixels}${unit}` : `${width}px`,
    ...style,
  };

  return (
    <Button
      htmlType={htmlType}
      id={label}
      className={`${className} button-box-shadow button-${size || "default"} ${
        !disable ? `outline-enabled` : `outline-disabled`
      }`}
      onClick={(e) => {
        e.preventDefault();
        !disable && onClick && onClick(e);
      }}
      style={{ ...styles }}
    >
      {icon && <span>{icon}</span>}
      {label && label}
    </Button>
  );
};

export default OutlineButton;
